import api from '@/api/_kine-clinical'
import { clinicalToken, openReeducation, message } from '@/utils/kine-reeducation'
import { clinicNow } from '@/utils/kine-clinical-time'

export default {
    data: () => ({ kine_context: { fuseau: '', reeducation: null, numero: null, bilan: null, seances: [] },
        kine_loading: false, kine_error: '', kine_candidates: [], kine_reevaluation: false, kine_sequence: 0 }),
    provide() { return { kineContext: this.kine_context } },
    computed: {
        kine_identity() {
            const user = this.$store.getters.authInfo || {}, role = this.$store.getters.activeRole || {}
            return JSON.stringify([user.id, user.access_token, role.id, role.nom])
        },
        mode_seance() { return !!this.kine_context.reeducation },
        groupes_kine_affiches() {
            if (!this.mode_seance) return this.consultation_group_sections
            const slugs = this.kine_reevaluation ? ['kine_seance', 'kine_goniometrie', 'kine_musculaire'] : ['kine_seance']
            return this.consultation_group_sections.map(group => Object.assign({}, group, {
                sections: group.sections.filter(section => slugs.includes(section.slug))
            })).filter(group => group.sections.length)
        }
    },
    watch: {
        kine_identity() { this.charger_reeducation() },
        'consultationEnCours.id'() { this.charger_reeducation() }
    },
    mounted() { this.charger_reeducation() },
    beforeDestroy() { this.kine_sequence++ },
    methods: {
        async charger_reeducation() {
            const sequence = ++this.kine_sequence, id = Number(this.consultationEnCours.id), identity = this.kine_identity
            Object.assign(this.kine_context, { fuseau: '', reeducation: null, numero: null, bilan: null, seances: [] })
            this.kine_candidates = []; this.kine_error = ''; this.kine_reevaluation = false; this.kine_loading = false
            if (this.mode_complement) {
                this.kine_context.fuseau = (this.consultationEnCours.complement || {}).fuseau || ''
                return
            }
            if (!id || this.activeRole !== 'ROLE_MEDECIN' || process.env.VUE_APP_KINE_CLINICAL_ENABLED !== 'true') return
            const current = () => !this._isDestroyed && sequence === this.kine_sequence && identity === this.kine_identity && Number(this.consultationEnCours.id) === id && this.activeRole === 'ROLE_MEDECIN'
            this.kine_loading = true
            try {
                const token = await clinicalToken(current)
                const tableau = await api.getTableau({ onglet: 'aujourdhui', page: 1, search: '' }, token)
                if (!current()) return
                clinicNow(new Date(), tableau.fuseau)
                this.kine_context.fuseau = tableau.fuseau
                const type = ((this.consultationEnCours.tarif_consultation || {}).type_consultation || {}).id
                if (!(tableau.specialites && tableau.specialites.suivies || []).map(Number).includes(Number(type))) return
                const opened = await openReeducation(id, token, current)
                if (!current() || !opened) return
                this.kine_candidates = opened.candidates
                if (opened.reeducation) await this.lire_reeducation(opened, token, current)
            } catch (error) { if (current()) this.kine_error = message(error) }
            finally { if (current()) this.kine_loading = false }
        },
        async lire_reeducation(opened, token, current) {
            const response = await api.getReeducation(opened.reeducation.id, token)
            if (!current()) return
            const data = response.data
            clinicNow(new Date(), data.fuseau)
            Object.assign(this.kine_context, data, { numero: opened.numero })
            this.kine_candidates = []
            this.ouvrir_groupe_seance()
        },
        ouvrir_groupe_seance() {
            this.consultation_group_sections.forEach(group => {
                if (group.sections.some(section => section.slug === 'kine_seance')) {
                    this.$set(this.groupes_ouverts, group.groupe_id, true)
                    this.$set(this.groupes_charges, group.groupe_id, true)
                }
            })
        },
        async choisir_reeducation(row) {
            if (this.kine_loading) return
            const sequence = this.kine_sequence, id = Number(this.consultationEnCours.id), identity = this.kine_identity
            const current = () => !this._isDestroyed && this.kine_sequence === sequence && identity === this.kine_identity && Number(this.consultationEnCours.id) === id && this.activeRole === 'ROLE_MEDECIN'
            this.kine_loading = true; this.kine_error = ''
            try {
                const token = await clinicalToken(current)
                const response = await api.attachReeducation(id, row.id, token)
                if (current()) await this.lire_reeducation(response.data, token, current)
            } catch (error) { if (current()) this.kine_error = message(error) }
            finally { if (current()) this.kine_loading = false }
        }
    }
}
